export default __webpack_public_path__ + "static/media/image_upload.3188b124.svg";